// Shared copy for every "Share" action on the site, so a link sent to
// WhatsApp, Twitter, email or the native share sheet reads the same way:
//
//   📖 Read this article on Tykkit!
//
//   <title>
//   <optional detail lines, e.g. date / venue>
//
//   Check out the full article on Tykkit 📰
//
//   <url>
//
// The image/title card under the message is not built here — chat apps fetch
// it from the shared page's og:* tags (lib/generateMetadata.js).

const SHARE_COPY = {
  event: {
    intro: "🎟️ Check out this event on Tykkit!",
    outro: "Book your tickets on Tykkit 👇",
  },
  blog: {
    intro: "📖 Read this blog on Tykkit!",
    outro: "Check out the full blog on Tykkit 📰",
  },
  artist: {
    intro: "🎤 Discover this artist on Tykkit!",
    outro: "See their upcoming events on Tykkit 👇",
  },
  organizer: {
    intro: "🎪 Check out this organizer on Tykkit!",
    outro: "See all their events on Tykkit 👇",
  },
  venue: {
    intro: "📍 Check out this venue on Tykkit!",
    outro: "See what's happening there on Tykkit 👇",
  },
  contest: {
    intro: "🏆 Join this contest on Tykkit!",
    outro: "Take part on Tykkit 👇",
  },
};

/** Message body without the URL — for share targets that add the URL themselves. */
export function buildShareText({ type = "event", title, details = [] }) {
  const copy = SHARE_COPY[type] || SHARE_COPY.event;
  const body = [title, ...details]
    .map((line) => (typeof line === "string" ? line.trim() : ""))
    .filter(Boolean)
    .join("\n");

  return [copy.intro, body, copy.outro].filter(Boolean).join("\n\n");
}

/** Full message with the URL last, so chat apps unfurl it into a preview card. */
export function buildShareMessage({ url, ...rest }) {
  const text = buildShareText(rest);
  return url ? `${text}\n\n${url}` : text;
}
